import React, { JSX, useState } from "react";
import styled from "styled-components";
import { useWindowDimensions } from "@utils/window";

interface FileInputProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "onChange" | "children"> {
	multiple?: boolean;
	onChange?: (files: File[] | null) => void;
	children: (dragging: boolean) => JSX.Element;
	type?: "file" | "image" | "pdf" | "video" | "document";
	disabled?: boolean;
}
export const FileInput: React.FC<FileInputProps> = ({ multiple, onChange, children, type, disabled, ...htmlProps }) => {
	const [dragging, setDragging] = useState(false);
	const { width: maxWidth } = useWindowDimensions();

	return (
		<Container
			{...htmlProps}
			onDragEnter={() => setDragging(true)}
			onDragLeave={() => setDragging(false)}
			onDragOver={() => setDragging(true)}
			onDrop={() => setDragging(false)}
			disabled={disabled}
		>
			{children(dragging)}
			<input
				disabled={disabled}
				type="file"
				accept={
					type === "image"
						? "image/*"
						: type === "document"
							? "image/*,application/pdf"
							: type === "video"
								? "video/*"
								: type === "pdf"
									? "application/pdf"
									: "*"
				}
				multiple={multiple}
				onChange={(e) => {
					onChange?.(e.target.files ? Array.from(e.target.files) : null);
				}}
				style={{ maxWidth: maxWidth - 20 }}
			/>
		</Container>
	);
};

const Container = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "disabled",
})<{ disabled?: boolean }>`
	height: 100%;
	position: relative;

	input[type="file"],
	input[type="file"]::-webkit-file-upload-button {
		cursor: pointer;
		${({ disabled }) => disabled && "pointer-events:none;"}
		appearance: none;
		position: absolute;
		display: block;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		opacity: 0;
		width: 100%;
	}
`;
